import { createFileRoute } from "@tanstack/react-router";
import PortalPage from "src/components/app/PortalPage/PortalPage";
import TransfersPage from "src/components/app/TransfersPage/TransfersPage";
import DocLink from "src/components/docs/DocLink/DocLink";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { raceLoaderData } from "src/lib/LoaderResult";
import { getTransfersPageData } from "src/server/functions/Portal";
import { useExtracted } from "#i18n";

export const Route = createFileRoute("/_authed/portal/transfers")({
  loader: () => raceLoaderData(getTransfersPageData()),
  component: TransfersRoute,
});

function TransfersRoute() {
  const translateMessage = useExtracted();
  return (
    <PortalPage>
      <PortalPage.Header>
        <PortalPage.Heading>
          <PortalPage.Title>{translateMessage("Transfers")}</PortalPage.Title>
          <PortalPage.Description>
            {translateMessage("Projects and organisations offered to you.")}
          </PortalPage.Description>
          <PortalPage.Docs>
            <DocLink topic="organisations" />
          </PortalPage.Docs>
        </PortalPage.Heading>
      </PortalPage.Header>
      <PortalPage.Content>
        <DeferredLoaderData result={Route.useLoaderData()}>
          {(data) => <TransfersPage initialTransfers={data?.initialTransfers} />}
        </DeferredLoaderData>
      </PortalPage.Content>
    </PortalPage>
  );
}
